/**
 * @generated SignedSource<<31d037e92fd5b515c4b6fd34e0002f15>>
 * @relayHash 7d32c8336e50d9af2eaa064c10c8459b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0c1258f05946117d1c09b0453d98adb138b614c69457279bb38c530c1d837f2d

import type { ConcreteRequest } from 'relay-runtime';
export type JsmChannelsExperience = "EMPLOYEE_ONBOARDING_AGENT" | "EMPLOYEE_SERVICE_AGENT" | "%future added value";
export type ResolutionPlanSSRResourcePreviewModeQuery$variables = {
  experience: JsmChannelsExperience;
  jiraProjectAri: string;
};
export type ResolutionPlanSSRResourcePreviewModeQuery$data = {
  readonly jsmChannels_isPreviewModeEnabled: {
    readonly __typename: "JsmChannelsPreviewModeConfiguration";
    readonly enabled: boolean;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type ResolutionPlanSSRResourcePreviewModeQuery = {
  response: ResolutionPlanSSRResourcePreviewModeQuery$data;
  variables: ResolutionPlanSSRResourcePreviewModeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experience"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraProjectAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "kind": "Variable",
    "name": "jiraProjectAri",
    "variableName": "jiraProjectAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "enabled"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ResolutionPlanSSRResourcePreviewModeQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "jsmChannels_isPreviewModeEnabled",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/)
            ],
            "type": "JsmChannelsPreviewModeConfiguration"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ResolutionPlanSSRResourcePreviewModeQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "jsmChannels_isPreviewModeEnabled",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ],
            "type": "JsmChannelsPreviewModeConfiguration"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0c1258f05946117d1c09b0453d98adb138b614c69457279bb38c530c1d837f2d",
    "metadata": {},
    "name": "ResolutionPlanSSRResourcePreviewModeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "802bbb6e2d9ff61e2e97406a9418c306";

export default node;
